@let currentViewType = currentViewType$ | async;
@let showEditPricesActions = showEditPricesActions$ | async;
@let priceListUpdateLoading = priceListUpdateLoading$ | async;
@let isPricesPage = isPricesPage$ | async;
@let displayPurchaseButton = displayPurchaseButton$ | async;
@let isPriceUploadEnabled = isPriceUploadEnabled$ | async;
@let isRapidReco = isRapidReco$ | async;

@if (
  showEditPricesActions ||
  isPricesPage ||
  (isPriceUploadEnabled && currentViewType === viewType.Edit) ||
  (currentViewType !== viewType.Edit && selectedProducts.length > 0)
) {
  <div
    class="product-footer"
    [ngClass]="{
      'product-footer--with-price': isPricesPage,
      'product-footer--with-rapid-reco': isRapidReco,
      'product-footer--with-purchase': displayPurchaseButton,
    }"
  >
    @if (currentViewType !== viewType.Edit && selectedProducts.length > 0) {
      <ng-container>
        <div class="product-footer-header">
          <rc-button
            data-qa="vs-products-mobile-footer-button-toggle"
            class="toggle-footer-btn"
            variant="quaternary"
            size="medium"
            (click)="toggleProductSelection()"
          >
            <div class="toggle-footer-btn__content">
              <div class="align-row">
                <p class="text" i18n="@@product-book_selection">selection</p>
                <div class="badge">
                  <span>{{ selectedProducts.length }}</span>
                </div>
              </div>
              <div class="align-row">
                <p class="text">{{ toggleProductsSelection ? ('action_open' | translateKey) : ('action_close' | translateKey) }}</p>
                <app-icon class="icon" [class.toggle-icon]="toggleProductsSelection" [name]="IconName.chevron_down"></app-icon>
              </div>
            </div>
          </rc-button>
        </div>
      </ng-container>
    }
    <div class="align-row product-footer-wrapper">
      <div class="product-footer-content">
        @if (isPriceUploadEnabled && currentViewType === viewType.Edit) {
          <div class="margin-input">
            <div class="margin-input__text">
              <span
                class="margin-input__count"
                [innerHTML]="'mass-price-upload_margin_products-selected' | translateKey: { number: productsByMarginCount } | safeHtml"
              ></span>
            </div>
            <div class="margin-input__input" [class.margin-input__input--disabled]="marginControl.disabled">
              <span class="margin-input__input__label">
                {{ 'mass-price-upload_margin-input-field' | translateKey }}
              </span>
              <form [formGroup]="form">
                <rc-field
                  id="marginInput"
                  type="number"
                  [formControlName]="'margin'"
                  [forceTypeNumber]="true"
                  [label]=""
                  [placeholder]="'0'"
                  (keydown)="onKeyDown($event)"
                  (paste)="onPaste($event)"
                >
                  <ng-container suffix><span>%</span></ng-container>
                </rc-field>
              </form>
            </div>
          </div>
        }
        @if (currentViewType !== viewType.Edit && selectedProducts.length > 0 && !isPricesPage) {
          <div class="product-footer-items" [class.toggle-content]="toggleProductsSelection">
            @for (product of selectedProducts | slice: 0 : 3; track product.id) {
              <div class="product-item">
                <div class="product-item-content">
                  <img class="image" [src]="product.image | publicUrl: product.productType" [alt]="product.name || ''" />
                  <div>
                    <p class="type">
                      {{ product.productType | translationCode: LocaleContentEnum.ProductType }}
                    </p>
                    <p class="name">{{ product.name }}</p>
                  </div>
                </div>

                <rc-button
                  data-qa="vs-products-footer-button-remove-product"
                  class="close"
                  variant="tertiary"
                  size="small"
                  iconname="close"
                  rounded="true"
                  (click)="removeProduct.emit(product)"
                ></rc-button>
              </div>
            }
            @if ((selectedProducts.length === 1 || selectedProducts.length === 2) && !disableMultiSelection) {
              @if (showProductPlaceholder(ProductType.Dry)) {
                <div class="product-item--empty">
                  @if (allProductsTypeAvailable) {
                    <div class="message-information tooltip-arrow-down">
                      <div class="tooltip-content">{{ ('po-letter_feedingAdvice2Subtitle' | translateKey).toLowerCase() }}</div>
                    </div>
                  }
                  <p class="text" i18n="@@select-dry-product">Select a dry product</p>
                </div>
              }
              @if (showProductPlaceholder(ProductType.Wet)) {
                <div class="product-item--empty">
                  @if (allProductsTypeAvailable) {
                    <div class="message-information tooltip-arrow-down">
                      <div class="tooltip-content">{{ ('po-letter_feedingAdvice2Subtitle' | translateKey).toLowerCase() }}</div>
                    </div>
                  }
                  <p class="text" i18n="@@select-wet-product">Select a wet product</p>
                </div>
              }
              @if (showProductPlaceholder(ProductType.Treats)) {
                <div class="product-item--empty">
                  <p class="text" i18n="@@select-a-treat">Select a treat!</p>
                </div>
              }
            }
            @if (selectedProducts?.length > 2 && multiSelectionAvailable) {
              <rc-link
                data-qa="vs-products-footer-button-more-products"
                variant="secundary"
                size="large"
                (click)="openMoreProductsPopin.emit(selectedProducts)"
              >
                {{ 'and' | translateKey }} {{ selectedProducts.length - 2 }} {{ 'product-cart_more-products' | translateKey }}
              </rc-link>
            }
          </div>
        }
        <div class="product-footer-action">
          @if (currentViewType !== viewType.Edit && selectedProducts.length > 0 && !isPricesPage) {
            @if (withMobileSearch) {
              <div class="search-action">
                <rc-link data-qa="vs-products-footer-button-search" variant="primary" size="medium" (click)="searchAction.emit()">
                  {{ 'search' | translateKey }}
                </rc-link>
                @if (!displayPurchaseButton && !isRapidReco) {
                  <span class="separator" i18n="@@action_separator">or</span>
                }
              </div>
            }
            @if (displayPurchaseButton) {
              <rc-button
                id="productFooterPurchaseAction"
                data-qa="vs-products-footer-button-purchase-products"
                variant="secondary-alt"
                size="medium"
                (click)="openProductsPurchase()"
              >
                {{ 'new-DAC-flow_purchase_button' | translateKey }}
              </rc-button>
            }
            <div class="product-footer-action__group">
              @let isRRV2Enabled = isRRV2Enabled$ | async;
              @if (isRapidReco && isRRV2Enabled && !showContinueOnPrimaryButton) {
                @if (showWLPTooltip$ | async) {
                  <div #tooltipWLP class="tooltip-wlp tooltip-wlp--arrow">
                    <div class="tooltip-wlp__close-bt-container">
                      <div class="tooltip-wlp__close-bt" (click)="closeTooltip(tooltipWLP)">
                        <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.414 8l6.293-6.293A.999.999 0 1014.293.293L8 6.586 1.707.293A.999.999 0 10.293 1.707L6.586 8 .293 14.293a.999.999 0 101.414 1.414L8 9.414l6.293 6.293a.997.997 0 001.414 0 .999.999 0 000-1.414L9.414 8z"
                          ></path>
                        </svg>
                      </div>
                    </div>
                    <p class="tooltip-wlp--content">
                      {{ 'rrv3_satiety-product_include-dac' | translateKey }}
                    </p>
                  </div>
                }
                <rc-button
                  data-qa="vs-products-footer-button-include-da"
                  id="productFooterSecondaryContinueAction"
                  variant="secondary-alt"
                  size="medium"
                  iconname="plus"
                  iconposition="left"
                  [disabled]="isContinueDisabled()"
                  (click)="secondaryContinueAction.emit()"
                >
                  {{ 'include-daily-allowance' | translateKey }}
                </rc-button>
              }
              <rc-button
                [attr.data-qa]="
                  'vs-products-footer-button-' + (isRapidReco && !showContinueOnPrimaryButton ? 'share-recommendation' : 'continue')
                "
                variant="primary"
                size="medium"
                [disabled]="isContinueDisabled()"
                (click)="primaryContinueAction.emit()"
              >
                {{ (isRapidReco && !showContinueOnPrimaryButton ? 'action_share_recommendation' : 'action_continue') | translateKey }}
              </rc-button>
            </div>
          }
          @if (showEditPricesActions || isPricesPage || (isPriceUploadEnabled && currentViewType === viewType.Edit)) {
            @let disableButton = priceListUpdateLoading || !showEditPricesActions;
            <div class="product-footer-price-action">
              <div class="product-footer-buttons">
                @if (isMobile) {
                  <rc-button
                    id="footer-cancel-edit-prices"
                    data-qa="vs-products-footer-button-mobile-cancel"
                    class="product-footer-action__submit"
                    variant="secondary-alt"
                    size="medium"
                    [disabled]="disableButton"
                    (click)="cancelEditPrices()"
                  >
                    {{ (isPricesPage ? 'action_price-page_cancel' : 'exit_without_saving_button') | translateKey }}
                  </rc-button>
                } @else {
                  <rc-link
                    data-qa="vs-products-footer-button-cancel"
                    id="footer-cancel-edit-prices"
                    class="product-footer-action__submit"
                    variant="primary"
                    size="medium"
                    [disabled]="disableButton"
                    (click)="cancelEditPrices()"
                  >
                    {{ (isPricesPage ? 'action_price-page_cancel' : 'exit_without_saving_button') | translateKey }}
                  </rc-link>
                }

                @if (!isPricesPage) {
                  <span class="rc-button__separator" i18n="@@action_separator">or</span>
                }
                <rc-button
                  data-qa="vs-products-footer-button-save-all-prices"
                  id="footer-submit-edit-prices"
                  class="product-footer-action__submit"
                  variant="primary"
                  size="medium"
                  [disabled]="disableButton"
                  (click)="submitEditPrices()"
                >
                  @if (priceListUpdateLoading) {
                    <app-icon class="spinner disabled" [name]="IconName.spinner_circle"></app-icon>
                  } @else {
                    {{ 'action_price-page_save-all-prices' | translateKey }}
                  }
                </rc-button>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
